import { useSelector } from "react-redux"
import { useMutation } from "@tanstack/react-query"

import { API_PAYMENT_TOOLS_URL } from "../constants"
import { IPaymentLinkResponse } from "../interface"
import { RootState } from "../../store/store"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"

export async function linkRequest(
  bankId: string | undefined,
  token: string | null,
): Promise<IPaymentLinkResponse> {
  const response = await axios(`${API_PAYMENT_TOOLS_URL}/link`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: {
      bankId,
      amount: 10,
    },
  })

  if (checkIsFailure(response.status)) {
    throw new Error("Ошибка")
  }

  return response.data
}

export const usePaymentLink = () => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useMutation({
    mutationFn: (bankId: string) => linkRequest(bankId, token),
  })
}
